

(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function mount(el) {
    if (el.__cerusUgcMounted) return;
    if (!window.Splide) return;
    el.__cerusUgcMounted = true;

    var splide = new window.Splide(el, {
      type: 'loop',
      perPage: 4,
      gap: '20px',
      focus: 0,
      start: 0,
      omitEnd: true,
      arrows: false,
      pagination: false,
      drag: 'free',
      flickPower: 360,
      padding: { left: 2, right: 2 },
      breakpoints: {
        1100: { perPage: 3 },
        750:  { perPage: 2.2, gap: '14px' },
        500:  { perPage: 1.4, gap: '12px' }
      },
      autoScroll: {
        speed: 0.6,
        pauseOnHover: true,
        pauseOnFocus: false
      }
    });


    var AutoScroll =
      (window.Splide && window.Splide.Extensions && window.Splide.Extensions.AutoScroll) ||
      (window.splide && window.splide.Extensions && window.splide.Extensions.AutoScroll) ||
      null;
    try {
      if (AutoScroll) {
        splide.mount({ AutoScroll: AutoScroll });
      } else {
        splide.mount();
      }
    } catch (mountErr) {
      try {
        splide.mount();
      } catch (mountErr2) {
        el.classList.add('is-fallback');
      }
    }
    el.__cerusSplide = splide;

    var section = el.closest('.cerus-section') || document;
    var progress = $('[data-cerus-ugc-progress]', section);
    if (progress) {
      var total = splide.length || 1;
      var perCycleSeconds = Math.max(8, total * 4);
      progress.style.setProperty('--ugc-cycle', perCycleSeconds + 's');
      progress.classList.add('is-running');
      try {
        splide.on('autoScroll:play', function () { progress.classList.add('is-running'); });
        splide.on('autoScroll:pause', function () { progress.classList.remove('is-running'); });
      } catch (e) {  }
    }

    $$('[data-cerus-ugc-card]', section).forEach(function (card) {
      card.addEventListener('click', function () {
        var video = card.querySelector('video');
        if (!video) return;
        if (card.classList.contains('is-playing')) {
          video.pause();
          card.classList.remove('is-playing');
          return;
        }

        $$('[data-cerus-ugc-card].is-playing', section).forEach(function (other) {
          var ov = other.querySelector('video');
          if (ov) ov.pause();
          other.classList.remove('is-playing');
        });

        if (!video.dataset.loaded) {
          var src = video.dataset.src;
          if (src) { video.src = src; video.dataset.loaded = '1'; }
        }
        video.play().catch(function () {  });
        card.classList.add('is-playing');
        try {
          if (splide.Components && splide.Components.AutoScroll) splide.Components.AutoScroll.pause();
        } catch (e) {  }
      });
    });
  }

  function unmount(el) {
    if (el && el.__cerusSplide) {
      try { el.__cerusSplide.destroy(); } catch (err) {  }
      el.__cerusSplide = null;
    }
    if (el) el.__cerusUgcMounted = false;
  }

  var initPolls = 0;
  function initAll(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    var els = Array.from(root.querySelectorAll('[data-cerus-ugc]'));
    if (!els.length) return;
    if (!window.Splide) {
      initPolls++;
      if (initPolls < 50) {
        setTimeout(function () { initAll(scope); }, 100);
      } else {
        els.forEach(function (el) { el.classList.add('is-fallback'); });
      }
      return;
    }
    els.forEach(function (el) {
      mount(el);
      setTimeout(function () {
        if (!el.classList.contains('is-initialized')) el.classList.add('is-fallback');
      }, 400);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-cerus-ugc]').forEach(unmount);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var section = document.getElementById('shopify-section-' + e.detail.sectionId);
      if (!section) return;
      var el = section.querySelector('[data-cerus-ugc]');
      if (!el || !el.__cerusSplide) return;
      try { el.__cerusSplide.Components.AutoScroll && el.__cerusSplide.Components.AutoScroll.pause(); } catch (err) {}
      var slides = el.querySelectorAll('.splide__slide');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].dataset.shopifyEditorBlock && slides[i].dataset.shopifyEditorBlock.indexOf(e.detail.blockId) !== -1) {
          el.__cerusSplide.go(i);
          break;
        }
      }
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      var section = document.getElementById('shopify-section-' + e.detail.sectionId);
      if (!section) return;
      var el = section.querySelector('[data-cerus-ugc]');
      if (el && el.__cerusSplide) {
        try { el.__cerusSplide.Components.AutoScroll && el.__cerusSplide.Components.AutoScroll.play(); } catch (err) {}
      }
    });
  }

  window.CerusUgc = { mount: mount, initAll: initAll };
})();
